export const EXIT_INTENT_SHOWN_KEY = 'exit-intent-shown';

export const EXIT_INTENT_WARMED_KEY = 'exit-intent-warmed';

export const IDLE_SECONDS = 30;

export const MOUSE_SENSITIVITY_PX = 20;

export const GRACE_PERIOD_MS = 5000;

export const DELAY_BEFORE_TRIGGER_MS = 300;

export const SCROLL_DOWN_THRESHOLD_PX = 500;

export const SCROLL_UP_DELTA_PX = 80;

export const SCROLL_UP_QUICK_MS = 400;

export const EDGE_SWIPE_ZONE_PX = 24;

export const EDGE_SWIPE_DRAG_PX = 40;

export const EXIT_INTENT_SIGNAL = {
  desktopMouseLeave: 'desktop_mouse_leave',
  idle: 'idle',
  mobileScrollBounce: 'mobile_scroll_bounce',
  mobileEdgeSwipe: 'mobile_edge_swipe',
  visibilityReturn: 'visibility_return',
} as const;

export type ExitIntentSignal = (typeof EXIT_INTENT_SIGNAL)[keyof typeof EXIT_INTENT_SIGNAL];
